export default __webpack_public_path__ + "static/media/logo.10af2811.webp";